import createReducer from "Common/reducerUtils/createReducer";
import { NAMESPACE } from "../constants";
import actionTypes from "./actionTypes";
import set from "lodash/set";
export const initialState = {
    [NAMESPACE]: {
        balance: undefined,
        history: []
    }
};
export default createReducer(initialState, {
    [actionTypes.API_GET_BALANCE_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].balance`, payload),
    [actionTypes.API_GET_REQUEST_STATISTICS_COMPLETED]: (state, { payload }) => set(state, `[${NAMESPACE}].history`, payload)
});
